import {z} from "zod/v4-mini"
import {anyImageOpResult, NativeImageSource} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {descriptorDefinition} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-descriptor"
import {remotelyColorLike} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            descriptor: descriptorDefinition,
            data: z.union([z.union([remotelyColorLike, z.instanceof(Float32Array)]), z.instanceof(NativeImageSource)]),
        }),
    },
}
